module.exports = __webpack_public_path__ + "img/senderrand-download-image.174f0f3c.svg";